import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { pdfPagesProgress$, pdfProgressText, PdfPagesProgress } from '../../../core/pdf-pages/with-pdf-pages';
import { LoaderService, LoaderState } from '../../../core/services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  show = false;
  /** What a long upload is doing: preparing PDF pages, then uploading them. Empty otherwise. */
  message = '';

  progress$: Observable<PdfPagesProgress | null> = pdfPagesProgress$;

  private requesting = false;
  private pdf: PdfPagesProgress | null = null;
  // Set once PDF pages are prepared; the upload that follows says so until every request is done.
  private uploadingPdf = false;
  private subscriptions = new Subscription();

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.subscriptions.add(this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.requesting = state.show;
        if (!state.show) this.uploadingPdf = false;
        this.update();
      }));
    this.subscriptions.add(this.progress$.subscribe((progress) => {
      if (this.pdf && !progress) this.uploadingPdf = true;
      this.pdf = progress;
      this.update();
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private update(): void {
    this.message = this.pdf ? pdfProgressText(this.pdf) : this.uploadingPdf ? 'Uploading…' : '';
    this.show = this.requesting || !!this.pdf || this.uploadingPdf;
  }
}
